import { useEffect, useState, useRef, useMemo } from "react";
import axios from "../../../../axios";
import {
  errorToast,
  successToast,
  warningToast,
} from "../../../../utils/toast";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";
import TimerImage from "../../../../Images/timeupimage.png";
import Loding from "../../../../componant/Loader/Loding";
import { useToast } from "@chakra-ui/react";
import {
  CheckCircle,
  XCircle,
  AlertCircle,
  Clock,
  SkipForward,
  ArrowRight,
  Info,
  HelpCircle,
} from "lucide-react";

const QuestionPage = (props) => {
  const toast = useToast({ position: "top" });
  const [t, i18n] = useTranslation();
  const [loading, setLoading] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [data, setData] = useState({});
  const [nextdata, setNextdata] = useState({});
  const [userdata, setUserdata] = useState({});
  const [selectedOption, setSelectedOption] = useState(null);
  const [correctAnswers, setCorrectAnswers] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);
  const [timeLeft, setTimeLeft] = useState(30);
  const [showButton, setShowButton] = useState(false);
  const [showTimerButton, setShowTimerButton] = useState(false);
  const [correctAnswer, setCorrectAnswer] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [TimeOut, setIsTimeout] = useState(false);
  const timerRef = useRef(null);

  const [completeData, setCompleteData] = useState({
    rightCount: 0,
    wrongCount: 0,
    skipCount: 0,
  });

  const fetchData = async () => {
    setLoading(true);
    setShowTimerButton(false);

    try {
      const response = await axios.get(`getUserQuestion`);
      if (response?.data) {
        setShowTimerButton(true);
        setData(response.data.result);

      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      fetchQuestions(i18n.language);
    }
  }, [data, i18n.language]);

  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      setTimerBasedOnQuesType(data.quesType);
      setIsDisabled(false);
      setIsSubmitted(false);
      setIsCorrect(false);
      setSelectedOption(null);
    }
  }, [data]);

  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      setShowButton(false);
      setIsTimeout(false);
      startTimer();
    }
  }, [questions]);

  const setTimerBasedOnQuesType = (quesType) => {
    if (quesType === "reasoning") {
      setTimeLeft(50);
    } else if (quesType === "maths") {
      setTimeLeft(60);
    } else {
      setTimeLeft(40);
    }
  };

  const fetchQuestions = async (language) => {
    setLoading(true);
    try {
      const fetchedQuestions = {
        question: language !== "hi" ? data.question : data.questionHin,
        options: language !== "hi" ? data.options : data.optionsHin,
      };
      setQuestions([fetchedQuestions]);
    } catch (error) {
      console.error("Error fetching questions:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    setIsSubmitted(false);
  };

  const handleSubmit = async () => {
    if (selectedOption === null) {
      toast({
        title: "Please select an option.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    setShowTimerButton(false);
    const obj = {
      questionId: data._id,
      answer: selectedOption,
      type: "submit",
    };
    try {
      const res = await axios.post(`submitAnswer/`, obj);

      if (res) {
        setLoading(true);

        const correctAnswer =
          i18n.language === "hi"
            ? res?.data.rightAnsHin
            : res?.data.rightAnsEng;
        setCorrectAnswer(correctAnswer);
        const isAnswerCorrect = selectedOption === correctAnswer;
        setIsCorrect(isAnswerCorrect);
        setIsSubmitted(true);

        if (isAnswerCorrect) {
          setCorrectAnswers(correctAnswers + 1);
          toast({
            title: "Correct Answer!",
            status: "success",
            duration: 2000,
            isClosable: true,
          });
        } else {
          toast({
            title: "Incorrect Answer!",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        }

        setTimeout(() => {
          setSelectedOption(null);
          setLoading(false);
          // setData(null);
          setShowTimerButton(true);
          axios.get(`getUserQuestion`).then((res) => {
            setData(res?.data?.result);
            setTimerBasedOnQuesType(res?.data?.result?.quesType);
          });
        }, 3000);
      }
    } catch (error) {
      console.error("Error submitting answer:", error);
    }
  };

  const handleSkip = async () => {
    setShowTimerButton(false);
    const obj = {
      questionId: data._id,
      type: "skip",
    };
    try {
      const res = await axios.post(`submitAnswer/`, obj);

      if (res) {
        setLoading(true);
        const correctAnswer =
          i18n.language === "hi"
            ? res?.data.rightAnsHin
            : res?.data.rightAnsEng;
        setCorrectAnswer(correctAnswer);
        const isAnswerCorrect = selectedOption === correctAnswer;
        setIsCorrect(isAnswerCorrect);
        setIsSubmitted(true);

        if (isAnswerCorrect) {
          setCorrectAnswers(correctAnswers + 1);
          toast({
            title: "Correct Answer!",
            status: "success",
            duration: 2000,
            isClosable: true,
          });
        } else {
          toast({
            title: "Skipped",
            status: "info",
            duration: 3000,
            isClosable: true,
          });
        }

        setTimeout(() => {
          setSelectedOption(null);
          setLoading(false);
          setData(null);
          setShowTimerButton(true);
          axios.get(`getUserQuestion`).then((res) => {
            setData(res?.data?.result);
            setTimerBasedOnQuesType(res?.data?.result?.quesType);
          });
        }, 3000);
      }
    } catch (error) {
      console.error("Error submitting answer:", error);
    }
  };

  const handleNextQuestion = () => {
    setShowButton(false);
    setSelectedOption(null);
    setIsTimeout(false);
    setIsSubmitted(false);
    setIsCorrect(false);
    fetchData();
    clearInterval(timerRef.current);
    startTimer();
  };

  const startTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    timerRef.current = setInterval(() => {
      setTimeLeft((prevTimeLeft) => {
        if (prevTimeLeft <= 1) {
          clearInterval(timerRef.current);
          setShowButton(true);
          setIsDisabled(true);
          setIsTimeout(true);
          return 0;
        }
        return prevTimeLeft - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    if (userdata && Object.keys(userdata).length == 0) {
      axios
        .get("me")
        .then((response) => {
          setUserdata(response?.data?.result);
        })
        .catch((err) => {
          errorToast(err?.response?.data?.Comments);
        });
    }
  }, [userdata]);

  useEffect(() => {
    axios
      .get("me")
      .then((response) => {
        const userdata = response?.data?.result;
        setCompleteData({
          rightCount: userdata?.quizStats?.totalRight,
          wrongCount: userdata?.quizStats?.totalWrong,
          skipCount: userdata?.quizStats?.totalSkipped,
        });
      })
      .catch((err) => {
        errorToast(err?.response?.data?.Comments);
      });
  }, [data]);

  const generateOptionLabel = (index) => {
    return String.fromCharCode(65 + index);
  };

  const renderQuestion = () => {
    return (
      <>
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <Loding />
          </div>
        ) : (
          <div className="animate-fade-in-up relative">
            {/* Watermark Overlay */}
            <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden flex items-center justify-center opacity-[0.03]">
              <div className="transform -rotate-45 text-5xl md:text-7xl font-black text-white whitespace-nowrap select-none">
                Learn2Earn 24x7 Learn2Earn 24x7
                <br />
                Learn2Earn 24x7 Learn2Earn 24x7
                <br />
                Learn2Earn 24x7 Learn2Earn 24x7
                <br />
                Learn2Earn 24x7 Learn2Earn 24x7
              </div>
            </div>

            {/* Question Card */}
            <div className="bg-white/5 rounded-2xl p-6 mb-6 border border-white/10 relative z-10">
              <span className="text-gray-400 text-sm font-semibold uppercase tracking-wider mb-2 block">
                Question
              </span>
              {questions[0] && (
                <h2 className="text-xl md:text-2xl text-white font-bold leading-relaxed relative z-10">
                  {questions[0]?.question}
                </h2>
              )}
            </div>

            {/* Options Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 relative z-10">
              {questions[0]?.options?.map((option, index) => (
                <div
                  key={index}
                  className={`relative group cursor-pointer rounded-xl p-4 transition-all duration-300 border-2 transform hover:scale-[1.02] overflow-hidden
                    ${selectedOption === option && isSubmitted
                      ? isCorrect
                        ? "bg-green-500/20 border-green-500"
                        : "bg-red-500/20 border-red-500"
                      : selectedOption === option
                        ? "bg-purple-600/20 border-purple-500"
                        : "bg-white/5 border-white/10 hover:bg-white/10 hover:border-purple-500/50"
                    }`}
                  onClick={() =>
                    !isSubmitted &&
                    handleOptionChange({ target: { value: option } })
                  }
                >
                  {/* Small Watermark in options */}
                  <div className="absolute inset-0 flex items-center justify-center opacity-[0.02] pointer-events-none">
                    <span className="transform -rotate-12 text-2xl font-black text-white">
                      L2E 24x7
                    </span>
                  </div>

                  <div className="flex items-center gap-4 relative z-10">
                    <div
                      className={`w-10 h-10 flex items-center justify-center rounded-lg font-bold text-lg transition-colors ${selectedOption === option
                        ? "bg-purple-500 text-white"
                        : "bg-white/10 text-gray-400 group-hover:bg-white/20 group-hover:text-white"
                        }`}
                    >
                      {generateOptionLabel(index)}
                    </div>
                    <span className="text-base md:text-lg text-white font-medium flex-1">
                      {option}
                    </span>
                    {selectedOption === option && isSubmitted && (
                      <div className="animate-scale-in">
                        {isCorrect ? (
                          <CheckCircle className="text-green-500" size={24} />
                        ) : (
                          <XCircle className="text-red-500" size={24} />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <div className="min-h-screen bg-[#2A1B3D] pt-16 pb-20 px-4 flex flex-col items-center">
      {/* Header Stats */}
      <div className="w-full max-w-5xl flex justify-between items-center mb-8 bg-[#3F234E] p-4 rounded-2xl border border-white/5 shadow-lg">
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-2">
            <CheckCircle className="text-green-500" size={20} />
            <span className="text-white font-bold text-lg">
              {completeData?.rightCount}
            </span>
            <span className="text-gray-400 text-xs uppercase hidden sm:inline">
              Correct
            </span>
          </div>
          <div className="w-px h-8 bg-white/10"></div>
          <div className="flex items-center gap-2">
            <XCircle className="text-red-500" size={20} />
            <span className="text-white font-bold text-lg">
              {completeData?.wrongCount}
            </span>
            <span className="text-gray-400 text-xs uppercase hidden sm:inline">
              Wrong
            </span>
          </div>
          <div className="w-px h-8 bg-white/10"></div>
          <div className="flex items-center gap-2">
            <AlertCircle className="text-yellow-400" size={20} />
            <span className="text-white font-bold text-lg">
              {completeData?.skipCount}
            </span>
            <span className="text-gray-400 text-xs uppercase hidden sm:inline">
              Skipped
            </span>
          </div>
        </div>

        <div
          className="flex items-center gap-2 text-gray-400 cursor-help"
          title="Rules"
        >
          <Info size={20} />
        </div>
      </div>

      <div className="w-full max-w-5xl flex flex-col lg:flex-row gap-8">
        {/* Main Question Area */}
        <div className="flex-1 order-2 lg:order-1">
          {data ? (
            renderQuestion()
          ) : (
            <div className="text-white text-center">Loading Question...</div>
          )}
        </div>

        {/* Timer & Controls Sidebar */}
        <div className="lg:w-80 order-1 lg:order-2 flex flex-col gap-6">
          {/* Timer Card */}
          <div className="bg-[#3F234E] rounded-3xl p-6 border border-white/5 flex flex-col items-center justify-center shadow-xl relative overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 bg-purple-500/10 rounded-full blur-3xl pointer-events-none"></div>

            {TimeOut ? (
              <div className="flex flex-col items-center text-center animate-pulse">
                <Clock size={48} className="text-red-500 mb-2" />
                <h3 className="text-xl font-bold text-white">Time's Up!</h3>
                <p className="text-gray-400 text-sm">Move to next question</p>
              </div>
            ) : (
              <div className="relative w-40 h-40">
                <CircularProgressbar
                  value={
                    (timeLeft /
                      (data?.quesType === "maths"
                        ? 60
                        : data?.quesType === "reasoning"
                          ? 50
                          : 40)) *
                    100
                  }
                  text={`${timeLeft}`}
                  styles={buildStyles({
                    rotation: 0.25,
                    strokeLinecap: "round",
                    textSize: "24px",
                    pathTransitionDuration: 0.5,
                    pathColor: timeLeft <= 10 ? "#ef4444" : "#a855f7",
                    textColor: "#fff",
                    trailColor: "rgba(255,255,255,0.1)",
                    backgroundColor: "transparent",
                  })}
                />
                <div className="absolute top-full left-0 w-full text-center -mt-8">
                  <span className="text-gray-400 text-sm">Seconds Left</span>
                </div>
              </div>
            )}
          </div>

          {/* Actions */}
          <div className="flex flex-col gap-3">
            {showButton ? (
              <button
                onClick={handleNextQuestion}
                className="w-full py-4 rounded-xl bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-bold shadow-lg shadow-purple-500/30 hover:scale-[1.02] active:scale-95 transition-all flex items-center justify-center gap-2"
              >
                Next Question <ArrowRight size={20} />
              </button>
            ) : (
              <button
                onClick={handleSubmit}
                disabled={isDisabled}
                className={`w-full py-4 rounded-xl font-bold shadow-lg flex items-center justify-center gap-2 transition-all hover:scale-[1.02] active:scale-95
                                ${isDisabled
                    ? "bg-gray-700 text-gray-400 cursor-not-allowed"
                    : "bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-green-500/30"
                  }`}
              >
                {t("Submit")}
              </button>
            )}

            <button
              onClick={handleSkip}
              disabled={isDisabled}
              className={`w-full py-4 rounded-xl font-bold border-2 flex items-center justify-center gap-2 transition-all hover:scale-[1.02] active:scale-95
                            ${isDisabled
                  ? "border-gray-700 text-gray-500 cursor-not-allowed"
                  : "border-white/10 text-gray-300 hover:bg-white/5 hover:text-white"
                }`}
            >
              Skip <SkipForward size={20} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionPage;
